module.exports = __webpack_public_path__ + "img/capability-branding.63ad6f88.png";